import React from 'react'

const AppearenceIcon = ({ formData, handleInputChange }) => {
  return (
    <div className="col-lg-9 ml-auto">
          <fieldset className='pl-0 mt-4 mb-4'>
            <legend className=''>
              Appearance<label htmlFor="firsticon">(Select an icon) <span className="mandatory">*</span> </label>
            </legend>
          
             
                <div className="signup-icon-container">
                {Array.from({ length: 22 }, (_, index) => (
              <div className="signup-icon" key={index}>
                <div>
                  <img src={`/images/icon-${index + 1}.png`} alt={`icon-${index + 1}`} />
                </div>
                <div className="icon-input">
                  <input
                    id={`icon${index}`}
                    name="icon"
                    type="radio"
                    value={`/images/icon-${index + 1}.png`}
                    checked={formData.icon === `/images/icon-${index + 1}.png` || formData.icon === `images/icon-${index + 1}.png`}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            ))}
               
              </div>
            
          </fieldset>
        </div>
  )
}

export default AppearenceIcon